import { combineReducers } from 'redux';
import forSelect from './forSelect';

export default combineReducers({ forSelect});
